module.exports = __webpack_public_path__ + "img/2025-ford-ranger.386beda8.png";